import { confirm } from 'owa-confirm-dialog';
import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import mailStore from 'owa-mail-store/lib/store/Store';
import getItemRightsManagementRestrictions from 'owa-mail-store/lib/utils/getItemRightsManagementRestrictions';

/**
 * Confirms the specified restriction is allowed, returns true if it is, returns false and displays a confirmation dialog if it's not.
 * @param itemId The id of the item to confirm restrictions against.
 * @param restrictionToConfirm The restriction to confirm. Note: Only one restriction in this object should be true.
 * @param messageToDisplay The message to display of the action is not allowed.
 */
export default function confirmItemActionAllowed(
    itemId: string,
    restrictionToConfirm: IRMRestrictions,
    messageToDisplay: string
): boolean {
    const item: ClientItem = mailStore.items.get(itemId);
    const itemRestrictions = getItemRightsManagementRestrictions(item);
    // To protect against multiple actions being passed in, confirm all possible actions.
    // An action is confirmed if either
    // 1. item is not S/MIME except print.
    // 2. restrictionToConfirm doesn't request it.
    // 3. item allows it.
    if (
        (!restrictionToConfirm.PrintAllowed || itemRestrictions.PrintAllowed) &&
        (!restrictionToConfirm.ForwardAllowed || itemRestrictions.ForwardAllowed) &&
        (!restrictionToConfirm.ReplyAllowed || itemRestrictions.ReplyAllowed) &&
        (!restrictionToConfirm.ReplyAllAllowed || itemRestrictions.ReplyAllAllowed)
    ) {
        return true;
    } else {
        // Show dialog indicating action is not allowed on this item/conversation
        confirm(null /* title */, messageToDisplay, false /* resolveImmediately */, {
            hideCancelButton: true,
        });
        return false;
    }
}
